import axios from "axios";
import { API_URL } from "../utils/constants";

export const axiosInstance = axios.create({
  baseURL: API_URL + "/api/v1/",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export const axiosPrivateInstance = axios.create({
  baseURL: API_URL + "/api/v1/",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export const axiosPrivateInstanceForm = axios.create({
  baseURL: API_URL + "/api/v2/",
  withCredentials: true,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});
